<template>
  <div>
    <input
      class="uploader"
      style="display:none"
      type="file"
      multiple=“true“
      @change="upload($event)"
      accept="image/png, image/gif, image/jpeg, image/bmp"
    >
    <el-progress
      v-if="isUploadingImg"
      :text-inside="true"
      :stroke-width="26"
      :percentage="percentage"
      status="success"
      class="mb-10"
      ></el-progress>
    <textarea :id="id" :value="value"></textarea>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce';
import { getOssToken, uploadFile } from '@/api/file.js';
import { getNewFileName } from '@/utils/index.js';

// A theme is also required
import 'tinymce/themes/silver';

// Any plugins you want to use has to be imported
import 'tinymce/plugins/paste'
import 'tinymce/plugins/link'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/code'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/image'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/print'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/media'
// import 'tinymce/plugins/table'

// Initialize the app
export default {
  name: 'tiny-mce',
  props: {
    id: {
      type: String,
      default: 'tinymceEditor'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isUploadingImg: false,
      index: 0,
      total: 0,
      dialogVisible: false,
      editor: null,
      init: true,
    }
  },
  watch: {
    value (val) {
      if (this.init && val && val != '<p><br></p>' && val != '<p><br data-mce-bogus="1"></p>') {
        this.init = false;
        this.$nextTick(() => tinymce.get(this.id).setContent(val))
      }
    }
  },
  mounted () {
    const _this = this
    this.init = true;
    this.editor = tinymce.init({
      base_url: 'https://fulishe-static.oss-cn-zhangjiakou.aliyuncs.com/static/tinymce/',
      height: 500,
      menubar: true,
      selector: `#${this.id}`,
      language: 'zh_CN',
      plugins: [
        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
        'print', 'preview', 'anchor',
        'searchreplace', 'visualblocks', 'code', 'fullscreen',
        'insertdatetime', 'media', 'paste', 'code'
      ],
      toolbar:
        'undo redo | formatselect | imageUpload| bold italic backcolor | \
        alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat',
      setup: function (editor) {
        function selectImages () {
          document.querySelector(".uploader").click();
        }
        editor.ui.registry.addButton('imageUpload', {
          icon: 'image',
          tooltip: '上传图片',
          onAction: selectImages
        })
        editor.on('NodeChange Change KeyUp', () => {
          _this.$emit('input', editor.getContent({ format: 'raw' }))
        })
      }
    });
  },
  computed: {
    percentage: function() {
      return Number(((Number(this.index) + 1) / this.total * 100).toFixed(0));
    }
  },
  methods: {
    async upload(event) {
      if (!event.target) return false;
      let files = event.target.files || [];
      this.total = files.length;

      if (this.total < 1) return false;

      // 显示loading动画
      this.isUploadingImg = true;
      let _index = 0;
      while (_index < files.length) {
        this.index = _index;
        await this.uploadFile(files[_index]);
        if (_index + 1 == this.total) {
          this.isUploadingImg = false;
          // 清空选中的文件，方式相同图片无法上传的问题
          document.querySelector(".uploader").value = '';
        }
        _index++;
      }
    },
    /**上传图片**/
    uploadFile(file) {
      // let file = event.target.files[0];
      if (!file) return;
      if (!file.type.endsWith("jpeg") && !file.type.endsWith("png") && !file.type.endsWith("gif") && !file.type.endsWith("bmp")) {
        this.$message({
          message: " 只能上传图片！",
          type: "error"
        });
        return;
      }

      return getOssToken('media/upload/').then(responseData => {
        let filename = responseData.dir + getNewFileName(file.name);
        return uploadFile(responseData, file, filename).then(() => {
          this.insertPic(responseData.host + '/' + filename);
        }).catch((err) => {
          console.log(err);
          this.$message({
            message: "图片上传失败，请重试",
            type: "error"
          });
        });
      })
    },
    //将图片插入编辑器
    insertPic(path) {
      this.init = false;
      let dom = tinymce.activeEditor.dom.createHTML('img', {src: path});
      tinymce.activeEditor.insertContent(dom);
      // tinymce.get(this.id).insertContent(
      //   tinymce.get(this.id).dom.createHTML('img', {src: path})
      // )
    },
  },
  destroyed () {
    this.init = true;
    tinymce.get(this.id).destroy()
  }
}
</script>
